import { createStyles as e } from "@mantine/core";
var n = Object.defineProperty, l = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable, c = (r, a, o) => a in r ? n(r, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[a] = o, p = (r, a) => {
  for (var o in a || (a = {}))
    t.call(a, o) && c(r, o, a[o]);
  if (l)
    for (var o of l(a))
      s.call(a, o) && c(r, o, a[o]);
  return r;
}, i = e((r, { noActive: a }) => {
  const o = r.fn.variant({ color: r.primaryColor, variant: "light" });
  return {
    control: {
      backgroundColor: r.colorScheme === "dark" ? r.colors.dark[6] : r.white,
      border: `1px solid ${r.colorScheme === "dark" ? r.colors.dark[4] : r.colors.gray[3]}`,
      color: r.colorScheme === "dark" ? r.colors.dark[0] : r.colors.gray[7],
      "&.ql-active": a ? {} : p({
        backgroundColor: o.background,
        color: o.color
      }, r.fn.hover({ backgroundColor: o.hover }))
    }
  };
});
export {
  i as default
};
